import React from 'react';
import PropTypes from 'prop-types';

import imgWhiteLogo from '../../assets/logos/assnture_logo.png';
import imgBlackLogo from '../../assets/logos/assnture_logo.png';

const FullLogo = ({ isDark, width, height }) => {
  return (
    <img
      src={isDark ? imgBlackLogo : imgWhiteLogo}
      alt="Logo"
      style={{
        width: width ?? 240,
        height: height ?? 78,
        objectFit: 'contain',
      }}
    />
  );
};

FullLogo.propTypes = {
  isDark: PropTypes.bool,
  width: PropTypes.any,
  height: PropTypes.any,
};

export default FullLogo;
